"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireDefault(require("../../component"));

var _header = _interopRequireDefault(require("./header.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CardHeader = function CardHeader(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      children = _ref.children;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, classes.main)
  }, children);
};

CardHeader.propTypes = {
  className: _propTypes["default"].string,
  classes: _propTypes["default"].object.isRequired,
  children: _propTypes["default"].node
};
CardHeader.defaultProps = {
  className: undefined,
  children: undefined
};

var _default = (0, _component["default"])({
  styles: _header["default"]
})(CardHeader);

exports["default"] = _default;